import { SyntheticEvent } from 'react'
import CreationToolUploadField from '../../../types/upload-field'
import CollapsibleField from './field-collapsible'
import Instructions from './field-instructions'

type Props = {
    className?: string
    field: CreationToolUploadField
    description: string
    isBulk?: boolean
    showDescriptionAsPlaceholder?: boolean
    showInstructions?: boolean
    onChange: (description: string) => void
}

const CreationDescriptionField = ({
    className,
    field,
    description,
    showDescriptionAsPlaceholder = false,
    showInstructions = false,
    isBulk = false,
    onChange,
}: Props) => {
    const placeholder = CreationToolUploadField.description(field)
    const maxLength = CreationToolUploadField.maxCharacterCount(field)

    const onInput = (e: SyntheticEvent<HTMLTextAreaElement, InputEvent>) => {
        onChange(e.currentTarget.value || '')
    }

    return (
        <CollapsibleField
            className={className}
            field={field}
            renderAsUploadFieldBlock
            titleSuffix={isBulk ? ` (Bulk)` : undefined}
        >
            <textarea
                {...{
                    defaultValue: description,
                    placeholder: showDescriptionAsPlaceholder ? description || placeholder : placeholder,
                    maxLength: maxLength || undefined,
                    onInput,
                }}
            />
            {showInstructions && <Instructions field={field} />}
        </CollapsibleField>
    )
}

export default CreationDescriptionField
